module.exports = __webpack_public_path__ + "front/img/poster3.4aa3e827.jpg";